import React from "react";

const ModalCloseIcon = (props) => {
	return (
		<svg
			width="58"
			height="58"
			viewBox="0 0 58 58"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g filter="url(#filter0_bd_1885_501689)">
				<rect
					x="54"
					width="50"
					height="50"
					rx="25"
					transform="rotate(90 54 0)"
					fill="url(#paint0_linear_1885_501689)"
					shapeRendering="crispEdges"
				/>
				<rect
					x="53.5"
					y="0.5"
					width="49"
					height="49"
					rx="24.5"
					transform="rotate(90 53.5 0.5)"
					stroke="#4E4B66"
					shapeRendering="crispEdges"
				/>
				<path
					d="M23 19L35.7742 31.7742"
					stroke="#A0A3BD"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M23 31.7744L35.7742 19.0002"
					stroke="#A0A3BD"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<filter
					id="filter0_bd_1885_501689"
					x="-26"
					y="-30"
					width="110"
					height="110"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood
						floodOpacity="0"
						result="BackgroundImageFix"
					/>
					<feGaussianBlur
						in="BackgroundImageFix"
						stdDeviation="15"
					/>
					<feComposite
						in2="SourceAlpha"
						operator="in"
						result="effect1_backgroundBlur_1885_501689"
					/>
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite
						in2="hardAlpha"
						operator="out"
					/>
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="effect1_backgroundBlur_1885_501689"
						result="effect2_dropShadow_1885_501689"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect2_dropShadow_1885_501689"
						result="shape"
					/>
				</filter>
				<linearGradient
					id="paint0_linear_1885_501689"
					x1="79"
					y1="0"
					x2="79"
					y2="50"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#191726" />
					<stop
						offset="1"
						stopColor="#050512"
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ModalCloseIcon;
